module.exports = __webpack_public_path__ + "static/bongo_cat_keyboard-d99b2c670d99269b41630690575554d3.gif";